import { useProjectPermissions } from 'hooks/useProjectPermissions'
import Input from 'ui/components/forms/Input/'
import { useUpdateWikiLink } from '../../../../hooks'
import Form from '../../../Form'

const WikiForm = ({ link, onCancel }) => {
  const { projectSlug } = useProjectPermissions()
  const { formik, isLoading } = useUpdateWikiLink(link, projectSlug)

  return (
    <Form
      onSubmit={async () => {
        await formik.submitForm()

        if (!formik.isValid) return false

        onCancel()
        return true
      }}
      onCancel={onCancel}
      onReset={() => formik.resetForm()}
      isSubmitting={isLoading}
      renderFields={() => (
        <Input
          id="editLinkInput"
          placeholder="https://"
          name="link"
          isClearable={true}
          meta={formik.getFieldMeta('link')}
          {...formik.getFieldProps('link')}
          onChange={(e) => {
            formik.setFieldValue('link', e?.target?.value ?? '')
          }}
        />
      )}
    />
  )
}

export default WikiForm
